import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ResponseList } from 'models';
import { F1PositionMaster } from 'models/user/Employee';

export type UseEmployeePositionsProps = {
    enabled?: boolean;
    sid?: string;
    platformId?: string;
};

export function useF1PositionMaster(props: UseEmployeePositionsProps) {
    const { enabled, sid, platformId } = props;

    return useQuery({
        enabled,
        queryKey: ['employee-position', { sid, platform_id: platformId }],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<F1PositionMaster>>('/v1/f1/employee-position', {
                signal,
                params: {
                    sid,
                    platform_id: platformId
                }
            }),
        select: response => response.data.result_list
    });
}
